import { useSubscription } from "@apollo/client";
import { useState } from "react";
import {
  DATA_IMPORT_COMPLETED_SUBSCRIPTION,
  DATA_IMPORT_PROGRESS,
} from "~/graphql/subscription/data-import";
import {
  FileDataImportCompleted,
  FileDataImportCompleted_fileDataImportCompleted,
} from "../../../../graphql/__generated_types__/FileDataImportCompleted";
import { FileDataImportProgress } from "../../../../graphql/__generated_types__/FileDataImportProgress";

export type ProgressState = {
  percentage: number;
  hasError: boolean;
};

type ImportCompletedState = {
  entityType: string;
  created: number;
  updated: number;
  deleted: number;
  importErrors: string[] | null;
};

export const useDataImportSubscription = (
  onImportCompleted?: (results: FileDataImportCompleted_fileDataImportCompleted) => void
) => {
  const [progress, setProgress] = useState<ProgressState>({ percentage: 0, hasError: false });
  const [dataImportResult, setDataImportresult] = useState<ImportCompletedState | undefined>(
    undefined
  );

  useSubscription<FileDataImportCompleted>(DATA_IMPORT_COMPLETED_SUBSCRIPTION, {
    onData: ({ data }) => {
      const completed = data.data?.fileDataImportCompleted;
      if (completed) {
        setDataImportresult(completed);
        onImportCompleted && onImportCompleted(completed);
      }
    },
  });

  useSubscription<FileDataImportProgress>(DATA_IMPORT_PROGRESS, {
    onError: (error) => {
      console.error(error);
    },
    onData: ({ data }) => {
      const progressSub = data.data?.fileDataImportProgress;
      if (progressSub) {
        setProgress({ percentage: progressSub.percentage, hasError: progressSub.hasError });
      }
    },
  });

  return { dataImportResult, progress, setProgress };
};
